import { render, staticRenderFns } from "./KeyValue.vue?vue&type=template&id=c79e81b2&scoped=true&"
import script from "./KeyValue.vue?vue&type=script&lang=js&"
export * from "./KeyValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c79e81b2",
  null
  
)

export default component.exports